import insuranceFormsDictionary from '../../ru/insurance-forms/insurance-forms.dic.json';

export const insuranceFormsNS = {
  INSURANCE_FORMS: insuranceFormsDictionary,
};

export const insuranceFormsNamespaces = ['INSURANCE_FORMS'];
